export default __webpack_public_path__ + "static/media/cakers.75b0a4b2.png";